import {
	todayTime,
	GetPreMonthDay,
	GetNextMonthDay,
	getFormatDate,
} from "../../../times/moment";
export default {
	methods: {
		// 获取上面的下拉选数据
		getOrgids(isFen = false) {
			let userInfo = this.getItem('wlwUserInfo') || {}
			let userInfos = JSON.parse(userInfo)
			let params = {
				orgId: '',
			}
			if (isFen) {
				params.orgId = this.allOrgId
			} else {
				params.orgId = userInfos.orgId
			}
			this.$http
				.getAction(this.$api.soilFindDeviceByOrgId, params)
				.then((res) => {
					console.log(res)
					if (res.meta.success) {
						let datas = res.data || []
						// datas = [];
						this.orgSelect = datas || []
						this.isorgSelect = true
						if (datas && datas.length) {
							this.$set(this.selectForm, 'facId', datas[0]['facId'])

							// 获取页面上相关的其它数据
							setTimeout(() => {
								// 获取详情数据
								this.getInfos()
								// 获取采集项
								this.getItemsSelect()
							}, 300)
						} else {
							this.orgSelect = []
							this.$set(this.selectForm, 'facId', '')
							this.isorgSelect = false
							this.loading = false

							// 清空相关详细数据
							this.clearInfos()
						}
					} else {
						this.orgSelect = []
						this.$set(this.selectForm, 'facId', '')
						this.isorgSelect = false
						this.loading = false
						// 清空相关详细数据
						this.clearInfos()
					}
				})
				.catch(() => {
					this.orgSelect = []
					this.$set(this.selectForm, 'facId', '')
					this.isorgSelect = false
					this.loading = false
					// 清空相关详细数据
					this.clearInfos()
				})
		},
		// 清空详情数据
		clearInfos() {
			this.infoData = {}
			this.infoList = []
			this.trEc = ''
			this.trPh = ''
			this.trDlz = ''
			this.trLlz = ''
			this.trJlz = ''
			this.trWd = []
			this.trSd = []
			this.isInfoList = false
		},
		// 获取设备下拉选
		getAllOrgids() {
			let userInfo = this.getItem('wlwUserInfo') || {}
			let userOrg = this.getItem('wlwOrg') || {}
			let userOrgs = JSON.parse(userOrg)
			let userInfos = JSON.parse(userInfo)
			let params = {
				parentOrgId: userInfos.orgId,
				type: '2',
			}
			this.$http
				.getAction(this.$api.findChildOrgByParentOrgId, params)
				.then((res) => {
					console.log(res)
					if (res.meta.success) {
						let datas = res.data || []
						this.orgAllSelect = datas || []
						if (datas && datas.length) {
							this.allOrgId = datas[0]['orgId']
							this.getOrgids(true)
						} else {
							this.loading = false
						}
					} else {
						this.orgSelect = []
						this.loading = false
					}
				})
				.catch(() => {
					this.orgSelect = []
					this.loading = false
				})
		},
		// 分公司网点下拉选选择
		changeAllOrg(val) {
			this.allOrgId = val
			this.getOrgids(true)
		},
		// 详情数据
		getInfos() {
			let params = this.selectForm
			this.$http
				.getAction(this.$api.soillatestDeviceData, params)
				.then((res) => {
					if (res.meta.success) {
						let datas = res.data || {}
						this.infoData = datas || {}
						let dataVos = datas.sensorVOs || []
						setTimeout(() => {
							this.infoList = dataVos || []
						}, 200)

						if (dataVos && dataVos.length) {
							this.isInfoList = true
							this.isWarn = false
							let data1 = []
							let data2 = []
							this.trEc = ''
							this.trPh = ''
							this.trDlz = '--'
							this.trLlz = '--'
							this.trJlz = '--'
							dataVos.forEach((item) => {
								if (item.key.indexOf('TRWD') > -1) {
									data1.push(item)
								} else if (item.key.indexOf('TRSD') > -1) {
									data2.push(item)
								}
								if (item.key.indexOf('EC') > -1) {
									this.trEc = item.value
								}
								if (item.key.indexOf('PH') > -1) {
									this.trPh = item.value
								}
								if (item.key == 'DLZ') {
									this.trDlz = item.value
									this.$nextTick(() => {
										// this.makeDanPie(item.value)
									})
								} else if (item.key == 'LLZ') {
									this.trLlz = item.value
									this.$nextTick(() => {
										// this.makeLinPie(item.value)
									})
								} else if (item.key == 'JLZ') {
									this.trJlz = item.value
									this.$nextTick(() => {
										// this.makeJiaPie(item.value)
									})
								}
							})
							this.trWd = data1
							this.trSd = data2
						} else {
							this.trWd = []
							this.trSd = []
							this.isWarn = true
							this.trEc = ''
							this.trPh = ''
							this.trDlz = '--'
							this.trLlz = '--'
							this.trJlz = '--'
							this.infoData = {}
							setTimeout(() => {
								this.infoList = []
							}, 200)
							this.isInfoList = false
						}
					} else {
						this.trWd = []
						this.trSd = []
						this.trEc = ''
						this.trPh = ''
						this.trDlz = ''
						this.trLlz = ''
						this.trJlz = ''
						this.infoData = {}
						setTimeout(() => {
							this.infoList = []
						}, 200)
						this.isInfoList = false
					}
				})
				.catch(() => {
					this.infoData = []
					this.isInfoList = false
					setTimeout(() => {
						this.infoList = []
					}, 100)
				})
				.finally((err) => {
					setTimeout(() => {
						this.loading = false
					}, 500)
				})
		},
		// 图表下拉选采集项
		getItemsSelect() {
			let params = this.selectForm
			this.$http
				.getAction(this.$api.soilgetDeviceItems, params)
				.then((res) => {
					if (res.meta.success) {
						let datas = res.data || []
						let twData = []
						let tsData = []
						if (datas && datas.length) {
							this.isShowLine = true
							// 处理层级数据
							datas.forEach((item) => {
								if (item.itemCode.indexOf('TRWD') > -1) {
									twData.push(item.itemCode)
								}
								if (item.itemCode.indexOf('TRSD') > -1) {
									tsData.push(item.itemCode)
								}
							})
							this.twData = twData
							this.tsData = tsData
							this.cengData = tsData
							this.$set(this.queryParam, 'listparam', 0)
							// 判断上面的详情是否有数据,没有数据设置占位空数据
							setTimeout(() => {
								let data1 = []
								let data2 = []
								datas.forEach((item) => {
									if (item.itemCode.indexOf('TRWD') > -1) {
										data1.push({
											key: item.itemCode,
											name: item.itemName,
											value: '--',
											unitName: item.itemUnitCode,
										})
									} else if (item.itemCode.indexOf('TRSD') > -1) {
										data2.push({
											key: item.itemCode,
											name: item.itemName,
											value: '--',
											unitName: item.itemUnitCode,
										})
									}
									if (!this.isInfoList) {
										if (item.itemCode.indexOf('EC') > -1) {
											this.trEc = '--'
										}
										if (item.itemCode.indexOf('PH') > -1) {
											this.trPh = '--'
										}
										if (item.itemCode == 'DLZ') {
											this.trDlz = '--'
										} else if (item.itemCode == 'LLZ') {
											this.trLlz = '--'
										} else if (item.itemCode == 'JLZ') {
											this.trJlz = '--'
										}
									}
								})
								if (!this.isInfoList || (!this.trWd.length && !this.trSd.length)) {
									this.trWd = data1
									this.trSd = data2
								}
							}, 300)

							this.$nextTick(() => {
								// 请求右下角折线图数据
								this.getLineData()
							})
						} else {
							this.queryParam.listparam = ''
							this.cengData = []
							this.isShowLine = false
						}
					} else {
						this.itemsSelect = []
						this.isShowLine = false
					}
				})
				.catch(() => {
					this.itemsSelect = []
					this.isShowLine = false
				})
		},
		changeOrg(val) {
			// 获取详情数据
			this.getInfos()
			// 获取采集项
			this.getItemsSelect()
		},
		// 查询点击
		searchTap() {
			let miao = this.queryParam.startTime.split(" ")[1] || "00:00:00";
			let preMonthDay = new Date(
				GetNextMonthDay(getFormatDate(this.queryParam.startTime), 6) +
				" " +
				miao
			); //6个月之后的日期
			let startTimeCuo = new Date(this.queryParam.endTime).getTime();
			if (startTimeCuo >= preMonthDay.getTime()) {
				this.$message("选择时间跨度范围不允许超过6个月", "warning");
				return false;
			}
			this.getLineData()
		},
		// 获取统计数据
		getLineData() {
			let listparam = this.queryParam.listparam;
			this.chartToCeng = listparam;
			let params = Object.assign({}, this.queryParam, this.selectForm)
			this.$set(params, 'list', [this.twData[listparam], this.tsData[listparam]])
			this.$set(params, 'deviceCode', this.selectForm.facId)
			this.$delete(params, 'listparam')
			this.$delete(params, 'facId')
			this.$http.postAction(this.url.lineChart, params).then(
				(res) => {
					if (res.meta.success) {
						this.isShowLine = true
						let datas = res.data || {}
						let xData = []
						let lenData = [] //类型数组
						let series = []
						Object.keys(datas).forEach((keys) => {
							xData.push(keys)
							datas[keys].forEach((item, index) => {
								let lenIndex = lenData.findIndex((kk) => {
									return kk == item.acquisitionItemName
								})
								if (lenIndex > -1) {
								} else {
									series.push({
										type: 'line',
										yAxisIndex: index,
										smooth: true,
										showSymbol: false,
										symbolSize: 10,
										itemStyle: {
											borderWidth: 8,
										},
										lineStyle: {
											width: 4,
										},
										name: item.acquisitionItemName,
										data: [],
									})
									lenData.push(item.acquisitionItemName)
								}
							})
						})
						xData.sort(function (a, b) {
							return b < a ? 1 : -1
						})
						xData.forEach((xitem, xindex) => {
							lenData.forEach((litem, lindex) => {
								series[lindex]['data'][xindex] = 0
								datas[xitem].forEach((ditem, dindex) => {
									if (ditem.acquisitionItemName == litem) {
										series[lindex]['data'][xindex] = ditem.acquisitionData
									}
								})
							})
						})
						if (xData.length) {
							this.isShowLine = true
							this.$nextTick(() => {
								this.lineChart(xData, series)
							})
						} else {
							let myChart = this.$echarts.init(this.$refs.qxChartRef)
							myChart.clear()
							this.isShowLine = false
						}
					} else {
						this.isShowLine = false
					}
				},
				(error) => {
					console.log('error')
					this.isShowLine = false
				}
			)
		},
		// 左侧折线图
		lineChart(xData, series) {
			console.log(xData, series)
			let max1 = Math.ceil(Math.max(...series[0].data) / 5)
			let max2 = Math.ceil(Math.max(...series[1].data) / 5)
			if (max1 == 0) {
				max1 = 1
			}
			if (max2 == 0) {
				max2 = 1
			}
			max1 = max1 * 5
			max2 = max2 * 5
			const _this = this
			let myChart = this.$echarts.init(this.$refs.qxChartRef)
			let option = {
				tooltip: {
					show: true,
					trigger: 'axis',
					backgroundColor: '#fff',
					padding: [14, 17],
					axisPointer: {
						type: 'line',
						lineStyle: {
							color: '#DADADA',
							type: 'solid',
							width: 2,
						},
					},
					extraCssText:
						'box-shadow: 0px 0px 12px 0px rgba(76, 216, 179, 0.33);text-align:left;font-size:14px;color:#3F3F3F;letter-spacing: 1px;',
					formatter: function (param) {
						let infos = ''
						let units = ''
						infos += `<div style="text-align:left;padding: 3px 0">${param[0].name
							}</div><div style="padding: 5px 0">第${_this.changeNumToHan(_this.chartToCeng + 1)}层${_this.queryParam.listparam + 1
							}0cm</div>`
						param.forEach((item, index) => {
							if (item.seriesName.indexOf('温') > -1) {
								units = '℃'
							} else {
								units = '%'
							}
							infos += `<div  style="padding: 5px 0;color:${item.color}">${item.seriesName}: ${item.value}${units}</div>`
						})
						return infos
					},
				},
				legend: {
					show: true,
					icon: 'rect',
					top: '3%',
					right: 'center',
					align: 'left',
					itemWidth: 22,
					itemHeight: 11,
					itemGap: 30,
					textStyle: {
						color: '#6B6B6B',
						fontSize: 12,
					},
				},
				color: ['#44A9FF', '#2DAEA9'],
				grid: {
					left: '5%',
					bottom: '15%',
					top: '14%',
					right: '6%',
				},
				xAxis: {
					type: 'category',
					data: xData,
					// 刻度线
					axisTick: {
						show: false,
					},
					axisLine: {
						lineStyle: {
							color: '#EDEDED',
							width: 2,
						},
					},
					axisLabel: {
						color: '#6B6B6B',
						fontSize: 14,
						lineHeight: 30,
					},
					boundaryGap: false,
				},
				yAxis: [
					{
						type: 'value',
						name: '（℃）',
						nameTextStyle: {
							color: '#6B6B6B',
							fontSize: 14,
							align: 'right',
						},
						axisLabel: {
							color: '#6B6B6B',
							fontSize: 14,
						},
						axisLine: {
							show: true,
							lineStyle: {
								color: '#EDEDED',
								width: 2,
							},
						},
						minInterval: 1,
						interval: max1 / 5,
						max: max1,
						splitNumber: 5,
					},
					{
						type: 'value',
						name: '（%）',
						positon: 'right',
						nameTextStyle: {
							color: '#6B6B6B',
							fontSize: 14,
							align: 'left',
						},
						axisLabel: {
							color: '#6B6B6B',
							fontSize: 14,
						},
						axisLine: {
							show: true,
							lineStyle: {
								color: '#EDEDED',
								width: 2,
							},
						},
						minInterval: 1,
						interval: max2 / 5,
						max: max2,
						splitNumber: 5,
					},
				],
				series: series,
			}
			myChart.clear()
			myChart.setOption(option)
			window.addEventListener('resize', function () {
				myChart.resize()
			})
		},
		makeDanPie(value) {
			let myChart = this.$echarts.init(this.$refs.pieDan)
			let colors = ['#56E19D', '#2DAEA9']
			let options = this.pieOption(value, '氮', colors)
			myChart.clear()
			myChart.setOption(options)
		},
		makeLinPie(value) {
			let myChart = this.$echarts.init(this.$refs.pieLin)
			let colors = ['#0491FA', '#0054D0']
			let options = this.pieOption(value, '磷', colors)
			myChart.clear()
			myChart.setOption(options)
		},
		makeJiaPie(value) {
			let myChart = this.$echarts.init(this.$refs.pieJia)
			let colors = ['#F8ED41', '#E4951E']
			let options = this.pieOption(value, '钾', colors)
			myChart.clear()
			myChart.setOption(options)
		},
		// 仪表盘
		pieOption(value, name, colors) {
			const _this = this
			let option = {
				tooltip: {
					show: false,
				},
				series: [
					{
						type: 'gauge',
						// 名称
						title: {
							color: '#454545',
							fontSize: 16,
							offsetCenter: [0, '105%'],
						},
						// 数值
						detail: {
							offsetCenter: [0, '0%'],
							formatter: '{a|' + value + '}{b|mg/KG}',
							rich: {
								a: {
									color: '#333',
									fontSize: 20,
									fontWeight: 'bold',
								},
								b: {
									color: '#333',
									fontSize: 10,
								},
							},
						},
						radius: '80%',
						startAngle: 235,
						endAngle: -55,
						axisLine: {
							lineStyle: {
								width: 20,
							},
						},
						splitLine: {
							show: false,
						},
						axisTick: {
							show: false,
						},
						// 进度条
						progress: {
							show: true,
							width: 20,
							itemStyle: {
								color: {
									type: 'linear',
									x: 1,
									y: 0,
									x2: 0,
									y2: 0,
									colorStops: [
										{
											offset: 0,
											color: colors[0], // 0% 处的颜色
										},
										{
											offset: 1,
											color: colors[1], // 100% 处的颜色
										},
									],
									global: false, // 缺省为 false
								},
							},
						},
						pointer: {
							show: false,
						},
						axisLabel: {
							show: false,
						},
						data: [
							{
								value: value,
								name: name,
							},
						],
					},
					{
						name: 'bg',
						type: 'gauge',
						radius: '120%',
						startAngle: 230,
						endAngle: -50,
						axisLine: {
							show: false,
						},
						splitLine: {
							show: false,
						},
						axisTick: {
							show: true,
							splitNumber: 3,
							length: 1,
							lineStyle: {
								width: 7,
								color: '#2DAEA9',
							},
						},
						// 进度条
						progress: {
							show: false,
						},
						pointer: {
							show: false,
						},
						axisLabel: {
							show: false,
						},
						detail: {
							show: false,
						},
						title: {
							show: false,
						},
					},
				],
			}
			return option
		},
		pieChart() {
			const _this = this
			let myChart = this.$echarts.init(this.$refs.pieDan)

			let option = {
				tooltip: {
					show: false,
				},
				series: [
					{
						type: 'gauge',
						// 名称
						title: {
							color: '#454545',
							fontSize: 16,
							offsetCenter: [0, '105%'],
						},
						// 数值
						detail: {
							offsetCenter: [0, '0%'],
							formatter: '{a|50}{b|%}',
							rich: {
								a: {
									color: '#333',
									fontSize: 20,
									fontWeight: 'bold',
								},
								b: {
									color: '#333',
									fontSize: 10,
								},
							},
						},
						radius: '80%',
						startAngle: 235,
						endAngle: -55,
						axisLine: {
							lineStyle: {
								width: 20,
							},
						},
						splitLine: {
							show: false,
						},
						axisTick: {
							show: false,
						},
						// 进度条
						progress: {
							show: true,
							width: 20,
							itemStyle: {
								color: {
									type: 'linear',
									x: 1,
									y: 0,
									x2: 0,
									y2: 0,
									colorStops: [
										{
											offset: 0,
											color: '#56E19D', // 0% 处的颜色
										},
										{
											offset: 1,
											color: '#2DAEA9', // 100% 处的颜色
										},
									],
									global: false, // 缺省为 false
								},
							},
						},
						pointer: {
							show: false,
						},
						axisLabel: {
							show: false,
						},
						data: [
							{
								value: 80,
								name: '氮',
							},
						],
					},
					{
						name: 'bg',
						type: 'gauge',
						radius: '120%',
						startAngle: 230,
						endAngle: -50,
						axisLine: {
							show: false,
						},
						splitLine: {
							show: false,
						},
						axisTick: {
							show: true,
							splitNumber: 3,
							length: 1,
							lineStyle: {
								width: 7,
								color: '#2DAEA9',
							},
						},
						// 进度条
						progress: {
							show: false,
						},
						pointer: {
							show: false,
						},
						axisLabel: {
							show: false,
						},
						detail: {
							show: false,
						},
						title: {
							show: false,
						},
					},
				],
			}
			myChart.clear()
			myChart.setOption(option)
		},
	},
}
